import InitialStepChatClosed from './chatClosed'

export default {
    InitialStepChatClosed
}
